import TuneIcon from "@mui/icons-material/Tune";
import { useState } from "react";

import styles from "./AIContextSettingsButton.module.css";
import { AIContextSettingsModal } from "./AIContextSettingsModal";

export function AIContextSettingsButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={styles.button}
        onClick={() => setOpen(true)}
        aria-label="Open AI context settings"
      >
        <TuneIcon className={styles.icon} />
        <span className={styles.label}>Context</span>
      </button>

      <AIContextSettingsModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
